/**
 * @module @mailonline/video-ad-sdk
 * @description Video ad SDK to load and play HTML5 video ads.
 */

import run from './runner/run';
import runWaterfall from './runner/runWaterfall';
import requestAd from './vastRequest/requestAd';
import requestNextAd from './vastRequest/requestNextAd';
import getDetails from './vastChain/getDetails';
import * as vastSelectors from './vastSelectors';

export {
  getDetails,
  run,
  runWaterfall,
  requestAd,
  requestNextAd,
  vastSelectors
};
